import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ajaxCall } from 'src/app/core/services/ajax-call.service';
import { MustEqualDirective } from 'src/app/core/validators.model';
import { LocalDatePipe } from 'src/app/core/pipes.model';
import { FocusMeDirective } from 'src/app/core/focus-me/focus-me.directive';

@Component({
  selector: 'app-delete-user',
  templateUrl: './delete-user.component.html',
  styles: [
  ]
})
export class DeleteUserComponent implements OnInit {
  @ViewChild(NgForm) deleteForm!: NgForm;

  userId: string;
  deleteUser: DeleteUserInformation = new DeleteUserInformation();
  submitAttempt: boolean;

  constructor(private ajax: ajaxCall,
    private modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.ajax.MakeCall<DeleteUserInformation>('/User/DeleteInfo', { userId: this.userId }).then((data) => {
      this.deleteUser = data;
    })
  }

  close(): void {
    this.modal.dismiss();
  }

  confirm(): void {
    this.submitAttempt = true;
    if (this.deleteForm.invalid) {
      return;
    }
    this.ajax.MakeCall<DeleteUserInformation>('/User/Delete', { userId: this.userId }).then((data) => {
      this.modal.close();
    });
  }
}

export class DeleteUserInformation {
  fullName: string;
  emailAddress: string;
  dateAdded: number;
  message: string;
}